import { gql } from "@apollo/client";

export const GET_PROVEEDOR_DISTRIBUIDOR_BY_ID = gql`
query ProveedorDistribuidorById($IdProveedorDistribuidor: Int!){
    proveedorDistribuidorById(idProveedorDistribuidor: $IdProveedorDistribuidor) {    
        idProveedorDistribuidor,
        codigoSAP,
        razonSocial,
        contacto,
        telefonoAdicional,
        observacion,
        activo,
        email,
        idDeposito,
        modalidadKMs {
            idProveedorMetodoCobroKM,
            idProveedorDistribuidor,
            valor,
            fechaDesde,
            fechaHasta
        },
        modalidadKilos {
            idProveedorMetodoCobroKilo,
            idProveedorDistribuidor,
            valor,
            valorExcedido,
            pesoLimite,
            fechaDesde,
            fechaHasta
        },
        modalidadBultos{
            idProveedorMetodoCobroBulto,
            idProveedorDistribuidor,
            cantidad,
            precio,
            fechaDesde,
            fechaHasta
        }
    }
  }
`;